"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const ArrowLeftRightIconDownSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.05 10.05L18 15L13.05 19.9501L11.636 18.536L14.172 15.999L1 16V14H14.172L11.636 11.464L13.05 10.05ZM4.95 0.0500488L6.364 1.46405L3.828 4.00005H17V6.00005H3.828L6.364 8.53605L4.95 9.95005L0 5.00005L4.95 0.0500488Z" fill="currentColor" />
  </svg>



)

const ArrowLeftRightIconDownIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowLeftRightIconDownSvg} {...props} />
);

export default ArrowLeftRightIconDownIcon